import React from 'react';

import currencyFormatter from 'currency-formatter';

import { Box, Stack, Typography } from '@mui/material';

interface Props {
  prices: App.AccommodationPackage['prices'];
}

const amountSx = {
  fontWeight: 700,
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
} as const;

export default function PriceList({ prices }: Props) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: 1.5,
      }}
    >
      {prices.map((priceData) => (
        <Box
          key={priceData.currency_code}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 2,
            minHeight: 112,
            '&:hover': {
              borderColor: 'grey.400',
            },
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: 0.4 }}>
            {priceData.currency_code}
          </Typography>
          <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={1}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }}
            >
              Price
            </Typography>
            <Typography variant="body2" sx={amountSx}>
              {currencyFormatter.format(priceData.price, { code: priceData.currency_code })}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={1}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }}
            >
              Value
            </Typography>
            <Typography variant="body2" sx={amountSx}>
              {currencyFormatter.format(priceData.value, { code: priceData.currency_code })}
            </Typography>
          </Stack>
        </Box>
      ))}
    </Box>
  );
}
